import React from 'react';
import Dialog from '../Dialog';

interface ConfirmCloseDialogProps {
    isOpen: boolean;
    onClose: () => void;
    onConfirm: () => void;
}

const ConfirmCloseDialog: React.FC<ConfirmCloseDialogProps> = ({
    isOpen,
    onClose,
    onConfirm
}) => {
    return (
        <Dialog
            isOpen={isOpen}
            onClose={onClose}
            width="w-[400px]"
            padding="p-6"
        >
            <div className="text-center">
                <h3 className="text-lg font-medium mb-4">Confirm Close</h3>
                <p className="text-gray-600 mb-6">Are you sure you want to close?</p>
                <div className="flex justify-center gap-4">
                    <button
                        onClick={onClose}
                        className="btn-secondary px-8"
                        id="cancel-confirm-button"
                    >
                        Cancel
                    </button>
                    <button
                        onClick={onConfirm}
                        className="btn-primary px-8"
                        id="confirm-close-button"
                    >
                        Close
                    </button>
                </div>
            </div>
        </Dialog>
    );
};

export default ConfirmCloseDialog; 